import React from "react";
import { Row, Col, Dropdown, Button } from "react-bootstrap";
import { Search } from "@material-ui/icons";
import FilterImg from "./../../../assets/img/filter.svg";
import moment from "moment";

import { connect } from "react-redux";
import {
  getActivityAction,
  getActivityUsersAction,
} from "./../../../actions/TransactionActions";

import DatePicker from "react-datepicker";

import ReactSelect from "react-select";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { cryptoTokenDecode } from "./../../Common/Common";

import "babel-polyfill";

const optionlist = [
  {
    value: "Document",
    label: "Document",
  },
  {
    value: "Comment",
    label: "Comment",
  },
  {
    value: "Task",
    label: "Tasks",
  },
  {
    value: "Email",
    label: "Email",
  },
  {
    value: "Text",
    label: "Text",
  },
];

var _ = require("lodash");

class Activity extends React.Component {
  constructor(props) {
    super(props);
    let userType = cryptoTokenDecode().usertype;
    this.state = {
      userRole: userType.toUpperCase(),
      showLoader: false,
      activities: [],
      originalActivities: [],
      searchParam: "",
      isFiltered: false,
      typeFilter: [],
      userFilter: [],
      sdateFilter: "",
      edateFilter: "",
      userList: [],
      initialValues: {
        byuser: [],
        bytype: [],
        sdate: "",
        edate: "",
      },
      users: [],
      showFilter: false,
      filterSelected: false,
    };
  }

  /**
   * @desc get user list to show for filter option by transaction id
   * this list contatins list of users of trasaction like - buyer, vendors, buyer agent
   */
  getUserList(transId) {
    let activityUsers = [];

    let buyer = this.props.transactionData.dsd.buyer;
    let buyerId = this.props.transactionData.dsd.buyerId;

    //If Undefined then prevent to push
    if (buyer.firstname !== undefined && buyer.lastName !== undefined) {
      let buyeruser = {
        value: buyerId,
        label: buyer.firstname + " " + buyer.lastName,
      };
      activityUsers.push(buyeruser);
    }

    let agent = {
      value: localStorage.getItem("email"),
      label:
        localStorage.getItem("fname") + " " + localStorage.getItem("lname"),
    };

    activityUsers.push(agent);

    this.props.getActivityUsersAction(transId).then((res) => {
      if (
        this.props.activityUsers !== undefined &&
        this.props.activityUsers !== null
      ) {
        for (let i = 0; i < this.props.activityUsers.length; i++) {
          if (
            this.props.activityUsers[i] !== undefined &&
            this.props.activityUsers[i] !== null
          ) {
            let usr = {
              value: this.props.activityUsers[i].email.address,
              label:
                this.props.activityUsers[i].firstname +
                " " +
                this.props.activityUsers[i].lastname,
            };
            activityUsers.push(usr);
          }
        }
      }

      this.setState({
        users: activityUsers,
      });
    });
  }

  componentWillMount() {
    let transId = this.props.transactionId;
    this.props.getActivityAction(transId).then((res) => {
      if (
        this.props.transactionActivities !== undefined &&
        this.props.transactionActivities !== null
      ) {
        let originalActivities = this.props.transactionActivities;
        originalActivities = _.orderBy(
          originalActivities,
          ["createdDate"],
          ["desc"]
        );

        this.setState({
          activities: this.formatActivity(originalActivities),
          originalActivities: originalActivities,
          showLoader: false,
        });
      }
    });
    this.getUserList(transId);
  }

  /**
   * @desc format activities to show based on date
   */
  formatActivity(originalActivities) {
    let activityByDate = {};
    for (let i = 0; i < originalActivities.length; i++) {
      let activity = originalActivities[i];
      let date = moment(activity.createdDate)
        .format("MM/DD/YYYY")
        .toString();
      activityByDate[date] = activityByDate[date] || [];
      activityByDate[date].push(activity);
    }
    return activityByDate;
  }

  searchActivity(param, afterFilter) {
    let originalActivities = this.state.originalActivities;
    let searchedActivity = [];

    let searchParam = param;
    if (afterFilter) {
      searchParam = this.state.searchParam;
    }

    if (searchParam !== "") {
      searchedActivity = originalActivities.filter((e) => {
        for (let i = 0; i < e.content.length > 0; i++) {
          if (
            e.content[i]
              .toLowerCase()
              .includes(searchParam.trim().toLowerCase())
          ) {
            return e.content[i]
              .toLowerCase()
              .includes(searchParam.trim().toLowerCase());
          }
        }
      });
    } else {
      searchedActivity = originalActivities;
    }
    if (
      this.state.userFilter !== null &&
      this.state.userFilter !== undefined &&
      this.state.userFilter.length > 0
    ) {
      //user filter
      searchedActivity = searchedActivity.filter((value, i) => {
        const userMatch =
          this.state.userFilter.length > 0
            ? this.state.userFilter.filter((e) => {
                return value.email
                  .toLowerCase()
                  .includes(e.value.trim().toLowerCase());
              }).length > 0
            : true;

        return userMatch;
      });
    }

    if (
      this.state.typeFilter !== null &&
      this.state.typeFilter !== undefined &&
      this.state.typeFilter.length > 0
    ) {
      //type filter
      searchedActivity = searchedActivity.filter((value, i) => {
        const typeMatch =
          this.state.typeFilter.length > 0
            ? this.state.typeFilter.filter((e) => {
                return value.activityname
                  .toLowerCase()
                  .includes(e.value.trim().toLowerCase());
              }).length > 0
            : true;

        return typeMatch;
      });
    }

    if (this.state.sdateFilter !== "" && this.state.edateFilter !== "") {
      //date filter
      searchedActivity = searchedActivity.filter((value, i) => {
        const dateRangeMatch =
          this.state.selectedDateRange !== ""
            ? moment(value.createdDate)
                .startOf("day")
                .isBetween(
                  this.state.sdateFilter,
                  this.state.edateFilter,
                  null,
                  "[]"
                )
            : true;

        return dateRangeMatch;
      });
    } else if (this.state.sdateFilter !== "" && this.state.edateFilter == "") {
      //date filter
      searchedActivity = searchedActivity.filter((value, i) => {
        const dateRangeMatch =
          this.state.selectedDateRange !== ""
            ? moment(value.createdDate)
                .startOf("day")
                .isBetween(
                  this.state.sdateFilter,
                  moment().format("YYYY-MM-DD"),
                  null,
                  "[]"
                )
            : true;

        return dateRangeMatch;
      });
    }

    this.setState({
      searchParam: searchParam,
      activities: this.formatActivity(searchedActivity),
      showFilter: false,
    });
  }

  /**
   * @desc function call on submit of filter option form - filter activity
   */
  filterActivity(filter) {
    this.setState({ isFiltered: true, showFilter: false });
    this.searchActivity("", true);
  }

  clearFilter() {
    let initialValues = {
      byuser: [],
      bytype: [],
      sdate: "",
      edate: "",
    };
    this.setState({
      isFiltered: false,
      initialValues: initialValues,
      showFilter: false,
      activities: this.formatActivity(this.state.originalActivities),
      typeFilter: [],
      userFilter: [],
      sdateFilter: "",
      edateFilter: "",
      searchParam: "",
    });
  }

  render() {
    let activityData = [];

    for (let key in this.state.activities) {
      let val = this.state.activities[key];

      let htmlCont = [];

      if (val.length > 0) {
        for (let i = 0; i < val.length; i++) {
          let content = [];
          for (let j = 0; j < val[i].content.length; j++) {
            if (
              !!val[i].activityname &&
              (val[i].activityname.toLowerCase() == "document added" ||
                val[i].activityname.toLowerCase() == "document deleted")
            ) {
              if (j === val[i].content.length - 1) {
                content.push(
                  <div className="file-info" key={"key" + i + j}>
                    <p className="file-title">{val[i].content[j]}</p>
                    <p className="file-auth">
                      by: {val[i].firstname + " " + val[i].lastname}{" "}
                      {moment(val[i].createdDate).format("LT")}
                    </p>
                  </div>
                );
              } else {
                content.push(
                  <div className="file-info" key={"key" + i + j}>
                    <p className="file-title">{val[i].content[j]}</p>
                  </div>
                );
              }
            } else {
              if (j === val[i].content.length - 1) {
                if (val[i].content == "") {
                  content.push(
                    <div className="file-info" key={"key" + i + j} />
                  );
                } else {
                  content.push(
                    <div className="file-info" key={"key" + i + j}>
                      <p className="file-text">"{val[i].content[j]}"</p>
                      <p className="file-auth">
                        by: {val[i].firstname + " " + val[i].lastname}{" "}
                        {moment(val[i].createdDate).format("LT")}
                      </p>
                    </div>
                  );
                }
              } else {
                content.push(
                  <div className="file-info" key={"key" + i + j}>
                    <p className="file-text">"{val[i].content[j]}"</p>
                  </div>
                );
              }
            }
          }

          htmlCont.push(
            <Row
              className="align-items-center activity-single"
              key={"activity" + key + i}
            >
              <Col>
                <h4 className="date">{key}</h4>
              </Col>
              <Col>
                <div className="activity-single-content">
                  <h4 className="title">
                    {val[i].activityname !== undefined
                      ? val[i].activityname
                      : "Transaction Event"}
                  </h4>

                  {val[i].description !== undefined && (
                    <h4 className="desc">{val[i].description}</h4>
                  )}
                  {content}
                </div>
              </Col>
            </Row>
          );
        }
      }

      if (htmlCont.length > 0) {
        activityData.push(
          <div className="activity-row" key={"data-" + key}>
            {htmlCont}
          </div>
        );
      }
    }

    return (
      <div className="activity">
        {this.state.showLoader ? (
          <div className="page-loader fixed">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        ) : (
          <div>
            <Row className="activity-header mx-0">
              <Col xs="4" />
              <Col xs="4" className="text-center">
                <h5>Activity</h5>
              </Col>

              <Col xs="4" className="activity-actions">
                <Row className="align-items-center">
                  <Col className="pr-0">
                    <div
                      className="icon-wrapper"
                      style={{ maxWidth: "200px", float: "right" }}
                    >
                      <input
                        type="text"
                        className="form-control-head form-control"
                        placeholder="Search"
                        value={this.state.searchParam}
                        onChange={(e) => {
                          this.searchActivity(e.target.value, false);
                        }}
                      />
                      <span className="form-control-icn">
                        <Search />
                      </span>
                    </div>
                  </Col>

                  <Formik
                    validateOnBlur={true}
                    initialValues={this.state.initialValues}
                    enableReinitialize={true}
                    validationSchema={Yup.object().shape({})}
                    onSubmit={(values) => {
                      this.filterActivity(values);
                    }}
                  >
                    {({ setFieldValue }) => (
                      <Form>
                        <Col className="col-auto px-0">
                          <Dropdown
                            alignRight
                            className="activity-filter"
                            show={this.state.showFilter}
                          >
                            <Dropdown.Toggle
                              variant="transparent"
                              id="dropdown-basic"
                              className="px-2"
                              onClick={(e) => {
                                this.setState({ showFilter: true });
                              }}
                            >
                              <img
                                src={FilterImg}
                                alt="filter"
                                style={{ width: "24px", height: "24px" }}
                              />
                            </Dropdown.Toggle>

                            <Dropdown.Menu className="activity-filter-menu">
                              <Row className="mb-3">
                                <Col xs="6">
                                  <h2 className="font-20 color-blue-4 mb-0">
                                    Filter
                                  </h2>
                                </Col>
                                <Col xs="6" align="right">
                                  <Button
                                    variant="link"
                                    className="p-0 font-14"
                                    onClick={() => this.clearFilter()}
                                  >
                                    Clear All
                                  </Button>
                                </Col>
                              </Row>
                              <Row className="mb-3">
                                <Col xs="12">
                                  <h4 className="font-12 color-blue-4">
                                    By User
                                  </h4>
                                </Col>
                                <Col xs="12">
                                  <ReactSelect
                                    isClearable={false}
                                    closeMenuOnSelect={false}
                                    placeholder="By User"
                                    isMulti
                                    options={this.state.users}
                                    className="react-select-wrapper react-select-multi"
                                    value={
                                      this.state.isFiltered
                                        ? this.state.userFilter
                                        : []
                                    }
                                    name="byuser"
                                    onChange={(e) => {
                                      setFieldValue("byuser", e);
                                      this.setState({
                                        isFiltered: true,
                                        userFilter: e,
                                      });
                                    }}
                                  />
                                </Col>
                              </Row>
                              <Row className="mb-3">
                                <Col xs="12">
                                  <h4 className="font-12 color-blue-4">
                                    Date Range
                                  </h4>
                                </Col>
                                <Col xs="6">
                                  Start
                                  <DatePicker
                                    selected={
                                      this.state.isFiltered
                                        ? this.state.sdateFilter
                                        : ""
                                    }
                                    onChange={(date) => {
                                      setFieldValue("sdate", date);
                                      this.setState({
                                        isFiltered: true,
                                        sdateFilter: date,
                                      });
                                    }}
                                    dateFormat="MM-d-yyyy"
                                    className="form-control form-control-sm pl-1 date-picker"
                                  />
                                </Col>
                                <Col xs="6">
                                  End
                                  <DatePicker
                                    selected={
                                      this.state.isFiltered
                                        ? this.state.edateFilter
                                        : ""
                                    }
                                    onChange={(date) => {
                                      setFieldValue("edate", date);
                                      this.setState({
                                        isFiltered: true,
                                        edateFilter: date,
                                      });
                                    }}
                                    dateFormat="MM-d-yyyy"
                                    className="form-control form-control-sm pl-1 date-picker"
                                  />
                                </Col>
                              </Row>
                              <Row className="mb-3">
                                <Col xs="12">
                                  <h4 className="font-12 color-blue-4">
                                    By type
                                  </h4>
                                </Col>
                                <Col xs="12">
                                  <ReactSelect
                                    isClearable={false}
                                    closeMenuOnSelect={false}
                                    placeholder="By type"
                                    isMulti
                                    options={optionlist}
                                    className="react-select-wrapper react-select-multi"
                                    onChange={(e) => {
                                      setFieldValue("bytype", e);
                                      this.setState({
                                        isFiltered: true,
                                        typeFilter: e,
                                      });
                                    }}
                                    value={
                                      this.state.isFiltered
                                        ? this.state.typeFilter
                                        : []
                                    }
                                    name="bytype"
                                  />
                                </Col>
                              </Row>
                              <Row>
                                <Col xs="12">
                                  <Button
                                    type="submit"
                                    variant="primary"
                                    className="btn-blue mr-2 w-140"
                                  >
                                    Apply
                                  </Button>
                                  <Button
                                    variant="primary"
                                    className="btn-blue btn-outlined w-140"
                                    onClick={() =>
                                      this.setState({
                                        showFilter: false,
                                        isFiltered: false,
                                      })
                                    }
                                  >
                                    Cancel
                                  </Button>
                                </Col>
                              </Row>
                            </Dropdown.Menu>
                          </Dropdown>
                        </Col>
                      </Form>
                    )}
                  </Formik>

                  <Col className="col-auto pl-0">
                    {this.state.isFiltered && (
                      <Button
                        variant="link"
                        className="font-12 p-0"
                        onClick={() => this.clearFilter()}
                      >
                        Clear
                      </Button>
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>
            <div className="activity-body">{activityData}</div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    transactionActivities: state.reducer.transactionActivities,
    activityUsers: state.reducer.activityUsers,
  };
};

export default connect(
  mapStateToProps,
  {
    getActivityAction,
    getActivityUsersAction,
  }
)(Activity);
